<template>
  <div class="nights-flight-details-component flex justify-between items-center" v-if="flightIsSet">
    <div class="flex flex-col items-center w-1/2 p-5">
      <div class="flex items-center space-x-4 mb-10 w-full">
        <div class="flight">
          <p class="paragraph-h-14 mb-2">
            {{ datetime('journey', 'Departure') | time }}
          </p>
          <p class="paragraph-h-14">
            ({{flight.routes[0].flyFrom}})
          </p>
        </div>
        <div class="duration color-brown-grey flex-grow">
          <p class="paragraph-h-16">
            {{ flight.journeyFlightDuration }}
          </p>
          <hr class="mx-auto border-t border-dashed border-semiDarkgrey h-0 w-full" />
          <p class="paragraph-h-16">{{ $tc('shared.stopOvers', 0) }}</p>
        </div>
        <div class="flight">
          <p class="paragraph-h-14 mb-2">
            {{ datetime('journey', 'Arrival') | time }}
          </p>
          <p class="paragraph-h-14">
            ({{flight.routes[0].flyTo}})
          </p>
        </div>
      </div>

      <div class="flex items-center space-x-4 w-full">
        <div class="flight">
          <p class="paragraph-h-14 mb-2">
            {{ datetime('journey', 'Departure') | time }}
          </p>
          <p class="paragraph-h-14">
            ({{flight.routes[0].flyFrom}})
          </p>
        </div>
        <div class="duration color-brown-grey flex-grow">
          <p class="paragraph-h-16">
            {{ flight.journeyFlightDuration }}
          </p>
          <hr class="mx-auto border-t border-dashed border-semiDarkgrey h-0 w-full" />
          <p class="paragraph-h-16">{{ $tc('shared.stopOvers', 0) }}</p>
        </div>
        <div class="flight">
          <p class="paragraph-h-14 mb-2">
            {{ datetime('journey', 'Arrival') | time }}
          </p>
          <p class="paragraph-h-14">
            ({{flight.routes[0].flyTo}})
          </p>
        </div>
      </div>
    </div>

    <!-- <div class="w-full lg:w-fit p-5 border-t border-borderGrey lg:border-none flex justify-end items-center">
      <span class="text-2xl font-black text-center">+0 €</span>
    </div> -->
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      moment,
    }
  },
  computed: {
    flight() {
      return this.$store.state.nights.flight;
    },
    flightIsSet() {
      return ! _.isEmpty(this.flight);
    },
  },

  methods: {
    datetime(direction, type) {
      return this.flight[`${direction}Flight${type}Time`];
    },
    name(type) {
      const { name } = this.$store.state.nights[type];
      return `${name} `;
    }
  },
}
</script>

<style scoped lang="scss">
.nights-flight-details-component {
  max-width: 740px;

  > div {
    overflow: hidden;
  }

  p {
    overflow-wrap: break-word;
    text-align: center;
    line-height: 1.25;
  }

  .flight {
    display: flex;
    flex-direction: column;
    align-self: stretch;

    p {
      flex-grow: 1;
    }

    p:first-child {
      font-size: 20px;
      font-weight: 900;
    }

    p:last-child {
      font-size: 16px;
    }
  }

  .duration {
    align-self: center;
  }
}
</style>


